import React, { useState } from "react";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { AddToHomeScreenRounded, CheckRounded, PhoneIphoneRounded } from "@mui/icons-material";
import LandingInstallSheet from "./LandingInstallSheet";

const PWA_BENEFITS = [
  "Opens from your home screen like an app",
  "No app store download required",
  "Always opens the latest version",
];

const LandingPwaInstallSection = () => {
  const [installOpen, setInstallOpen] = useState(false);

  return (
    <Box component="section" sx={{ px: 2, py: { xs: 6, md: 8 }, bgcolor: "#F8FAF7" }}>
      <Container maxWidth="lg">
        <Box sx={{ p: { xs: 3, sm: 4, md: 5 }, display: "grid", gridTemplateColumns: { xs: "1fr", md: "minmax(0, 1fr) auto" }, alignItems: "center", gap: { xs: 3, md: 6 }, border: "1px solid #DDE7E2", borderRadius: { xs: "24px", md: "30px" }, bgcolor: "#FFFFFF", boxShadow: "0 20px 55px rgba(39,67,56,0.07)" }}>
          <Box>
            <Typography sx={{ color: "#477765", fontSize: "0.74rem", fontWeight: 800, letterSpacing: "0.11em", textTransform: "uppercase" }}>Lifelog on your phone</Typography>
            <Typography component="h2" sx={{ mt: 1, maxWidth: 650, color: "#24342F", fontFamily: "'Fraunces', Georgia, serif", fontSize: { xs: "2rem", md: "2.75rem" }, fontWeight: 700, lineHeight: 1.08, letterSpacing: "-0.035em" }}>
              Keep Lifelog on your home screen.
            </Typography>
            <Typography sx={{ mt: 1.4, maxWidth: 680, color: "#687972", fontSize: { xs: "0.95rem", md: "1rem" }, lineHeight: 1.65 }}>
              Lifelog is a progressive web app. Add it to your phone once, then open it from your home screen whenever a care moment happens.
            </Typography>
            <Stack spacing={0.85} sx={{ mt: 2 }}>
              {PWA_BENEFITS.map((benefit) => <Stack key={benefit} direction="row" spacing={1} alignItems="center"><CheckRounded sx={{ color: "#679B88", fontSize: 19 }} /><Typography sx={{ color: "#53655D", fontSize: "0.9rem" }}>{benefit}</Typography></Stack>)}
            </Stack>
          </Box>

          <Box sx={{ minWidth: { md: 250 }, display: "flex", flexDirection: "column", alignItems: { xs: "stretch", md: "center" }, gap: 1.25 }}>
            <Box sx={{ width: 76, height: 76, mx: { xs: "auto", md: 0 }, display: "grid", placeItems: "center", borderRadius: "22px", color: "#477765", bgcolor: "#EAF4EF" }}><PhoneIphoneRounded sx={{ fontSize: 38 }} /></Box>
            <Button type="button" variant="contained" startIcon={<AddToHomeScreenRounded />} onClick={() => setInstallOpen(true)} sx={{ minHeight: 48, px: 2.6, borderRadius: "14px", bgcolor: "#477765", color: "#fff", textTransform: "none", fontWeight: 800, boxShadow: "none", "&:hover": { bgcolor: "#3E6C5B", boxShadow: "none" } }}>
              Add to home screen
            </Button>
            <Typography sx={{ color: "#8A9690", fontSize: "0.72rem", textAlign: "center" }}>Takes about 10 seconds</Typography>
          </Box>
        </Box>
      </Container>
      <LandingInstallSheet open={installOpen} onClose={() => setInstallOpen(false)} />
    </Box>
  );
};

export default LandingPwaInstallSection;
